import { ref } from "vue"
import { Network } from "@capacitor/network"

const isOnline = ref(true)

async function initOnlineListener() {
	// Initial check
	const status = await Network.getStatus()
	console.log("Network status", status)
	isOnline.value = status.connected

	Network.addListener("networkStatusChange", (state) => {
		isOnline.value = state.connected
		console.log("Network status changed", state)
	})
}

function removeOnlineListener() {
	Network.removeAllListeners()
}

export { isOnline, initOnlineListener, removeOnlineListener }
